import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-lg text-background-50"></i>
                </div>
                <span className="text-xl font-heading font-bold text-foreground-950">
                  天美影视
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                天美影视高清免费在线观看，不缓冲不卡顿流畅追剧。免费看最新高清电影电视剧全集，在线观看高清影视大全。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">影视分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(0, 6).map((cat) => (
                  <Link
                    key={cat.id}
                    to={cat.id === 'all' ? '/' : `/category/${cat.id}`}
                    className="text-sm text-foreground-400 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">更多分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(6).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.id}`}
                    className="text-sm text-foreground-400 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors">
                  品牌介绍
                </Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors">
                  联系我们
                </Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors">
                  用户协议
                </Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors">
                  隐私政策
                </Link>
              </div>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-400 hover:text-primary-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-400 hover:text-primary-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-400 hover:text-primary-500 transition-colors" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-300">
              &copy; 2026 天美影视 TianmeiYS.com 版权所有
            </p>
            <p className="text-xs text-foreground-300">
              天美影视高清免费在线观看 · 不缓冲不卡顿流畅追剧体验
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}